import { x } from '@xstyled/styled-components';
import { Button, ScreenContainer } from 'smooth-doc/components';
import { Link } from "gatsby";
import imageUrl from "../../../../pages/docs/images/404.png";
import logoNTT from "../../../../images/logo-ntt.svg";
import * as React from 'react';
export default {
  x,
  Button,
  ScreenContainer,
  Link,
  imageUrl,
  logoNTT,
  React
};